<template>
  <div v-loading="contanierLoading" class="view-contanier">
    <div class="header">
      <template v-if="!showForecast">
        <div class="tag">
          <span
            v-for="item in config.billStatusOptions"
            :key="item.value"
            v-permissson="`${item.permissson}`"
            :class="['tag-item', { 'tag-acitve': activeName === item.value }]"
            @click="handleClick('tag1', item.value, item.permissson)"
          >{{
            item.label +
              (item.value !== ""
                ? `(${tabNumer?.find((a) => a.type === +item.value)?.qty || 0})`
                : `(${allTotal})`)
          }}
          </span>
        </div>
        <div class="opt">
          <div v-if="filterList.date" class="checkDate flex_c_c">
            查询时间：{{ filterList.date[0] + "~" + filterList.date[1] }}
          </div>
          <div class="search">
            <el-popover
              ref="popover"
              placement="top"
              class="searchPop"
              title="批量搜索"
              trigger="click"
              width="378"
            >
              <div class="close" @click="closeSearchPanel">
                <i class="el-icon-close"></i>
              </div>
              <base-muti-input
                ref="baseMutiInput"
                v-model="referenceNumber"
                :default="referenceNumber"
              ></base-muti-input>
              <div style="text-align: right; margin: 16px 0 0">
                <el-button size="small" @click="handleEmpty">清空</el-button>
                <div class="sure" @mousedown="handleConfirm">确定</div>
              </div>
            </el-popover>
            <el-input
              :value="searchVal"
              placeholder="请输入提单号搜索"
              class="input-search"
              @focus="handleFocus"
            ></el-input>
            <div class="btn-search" @click="handleConfirm">
              <i class="el-icon-search"></i>
            </div>
          </div>
          <!-- <div class="hold" @click="hold">HOLD</div> -->
          <div v-debounce-click="batchExport" class="import">
            <img src="@/assets/images/bill/import.png" alt="" />导出
          </div>
          <div class="customer-list flex_c_c" @click="dialogVisible = true">
            <img src="@/assets/images/order/setting.png" />
            自定义列表
          </div>
          <div class="filter">
            <base-filter
              ref="BaseFilter"
              :isActive="isActive"
              :width="466"
              @sendFilter="sendFilter"
              @reset="reset"
            >
              <div class="filter">
                <SelectFilter
                  ref="selectFilter"
                  :filterListJson="filterListJson"
                  :filterListId="filterListId"
                  :companyDrapdown="companyDrapdown"
                  :pickUpOptions="pickUpOptions"
                  :clearenceOptions="clearenceOptions"
                  :originOptions="originOptions"
                  :destinationOptions="destinationOptions"
                  :userOptions="userOptions"
                  :customerOptions="customerOptions"
                  :operatorOptions="operatorOptions"
                  :transportOptions="shipTransportOptions"
                  tableCode="MBLSea"
                  @ok="ok1"
                ></SelectFilter>
                <!-- <el-form ref="form" :model="filterList" label-width="70px">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="创建日期">
                        <el-date-picker
                          v-model="filterList.date"
                          style="width: 320px"
                          type="daterange"
                          range-separator="至"
                          align="center"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="yyyy-MM-dd"
                          unlink-panels
                          :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="客户">
                        <el-select
                          v-model="filterList.companyId"
                          style="width: 320px"
                          filterable
                          placeholder="请选择客户"
                          multiple
                        >
                          <el-option
                            v-for="item in companyOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="activeName !== 0">
                    <el-col :span="12">
                      <el-form-item label="清关行">
                        <el-select
                          v-model="filterList.supplierClearenceIds"
                          style="width: 320px"
                          placeholder="请选择"
                          multiple
                        >
                          <el-option
                            v-for="item in clearenceOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="提货车行">
                        <el-select
                          v-model="filterList.pickUpSupplierIds"
                          style="width: 320px"
                          placeholder="请选择"
                          multiple
                        >
                          <el-option
                            v-for="item in pickUpOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="始发港">
                        <el-select
                          v-model="filterList.originHarborCodes"
                          style="width: 320px"
                          placeholder="请选择"
                          multiple
                        >
                          <el-option
                            v-for="item in originOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="目的港">
                        <el-select
                          v-model="filterList.destinationHarborCodes"
                          style="width: 320px"
                          placeholder="请选择"
                          multiple
                        >
                          <el-option
                            v-for="item in destinationOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="提单类型">
                        <el-select
                          v-model="filterList.classification"
                          style="width: 320px"
                          placeholder="提单类型"
                        >
                          <el-option
                            v-for="item in config.billTypeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="业务员">
                        <el-select
                          v-model="filterList.saleIds"
                          style="width: 320px"
                          filterable
                          placeholder="请选择"
                          multiple
                        >
                          <el-option
                            v-for="item in userOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form> -->
              </div>
            </base-filter>
          </div>
        </div>
      </template>
      <div v-show="showForecast" class="back" @click="back">
        <div class="back-blue" style="cursor: pointer">
          <img src="@/assets/images/bill/back.png" alt="" />
          <span>返回提单列表</span>
        </div>
        <img src="@/assets/images/bill/arrow.png" alt="" />
        <span>接受预报</span>
      </div>
      <div v-show="showForecast && !rowData.isType86" class="forecast-tip">
        <img
          src="@/assets/images/bill/warning.png"
        />Ctns总数须与提单件数一致，Gro.W总数须与提单重量一致
      </div>
    </div>
    <!-- <template v-if="!showForecast">
      <div
        v-if="activeName !== '' && activeName !== 4 && activeName !== 0 && permissson !== undefined"
        class="tag2"
      >
        <template v-for="(item, index) in config.billShipSubtabOptions">
          <div v-if="activeName == index && index != 4 && index != 0" :key="index">
            <span
              v-for="keys in item"
              :key="keys.value"
              class="tag-item"
              :class="{ 'tag-acitve': activeName2 === keys.value }"
              @click="handleClick('tag2', keys.value)"
            >{{
              keys.label +
                `(${
                  tabNumer
                    ?.find((a) => a.type === +activeName)
                    ?.subTab.find((a) => a.type === keys.value)?.qty || 0
                })`
            }}
            </span>
          </div>
        </template>
      </div>
    </template> -->
    <div v-loading="loading" class="data">
      <template v-if="!showForecast">
        <base-table
          v-if="height !== 0"
          :height="height"
          :tableData="tableData"
          :pageIndex="pagerConfig.pageIndex"
          :pageSize="pagerConfig.pageSize"
          :isEmptyBorder="true"
          @handlePageChange="handlePageChange"
          @handleSelectionChange="handleSelectionChange"
          @sortChange="sortChange"
          @dblclick="dblclick"
        >
          <template slot="transportName" slot-scope="row">
            <div
              v-if="
                row.scope.isRefuseForecast &&
                  row.scope.subStatus === 3 &&
                  activeName !== ''
              "
              class="isRefuse flex_c_c"
            >
              客户拒绝
            </div>
            <div v-if="row.scope.isOnLoadUpdate" class="isOnLoad flex_c_c">
              更改装载
            </div>
            <!-- {{ row.scope.transportName }} -->
            <!-- <p
              v-for="(filed, $i) in useFildList.find((a) => a.filed === 'transportName')
                ?.multipleParameters"
              :key="$i"
            >
              <span class="pickUpType" style="width: 50px;" :class="`pickUpType${$i}`">
                {{ filed.key }}
              </span>
              {{ row.scope[filed.value] }}
            </p> -->
            <p>
              <span class="pickUpType" style="width: 50px;" :class="`pickUpType0`">
                船公司
              </span>
              {{ row.scope.transportName }}
            </p>
            <p v-if="row.scope.containers && row.scope.containers.length > 0">
              <span class="pickUpType" style="width: 50px;" :class="`pickUpType1`">
                船名
              </span>
              {{ row.scope.containers[0]?.vesselName }}
            </p>
            <p v-if="row.scope.containers && row.scope.containers.length > 0">
              <span class="pickUpType" style="width: 50px;" :class="`pickUpType2`">
                船次
              </span>
              {{ row.scope.containers[0]?.voyageNo }}
            </p>
          </template>
          <template slot="forecastDate" slot-scope="row">
            {{ row.scope.forecastDate | dateFilete(0) }}
          </template>
          <template slot="createdOn" slot-scope="row">
            {{ row.scope.createdOn }}
            <p class="tips-box">
              <span
                v-if="
                  row.scope.dischargeHarbor &&
                    row.scope.originHarborName !== row.scope.dischargeHarbor
                "
                class="tips"
              >
                海铁联运
              </span>
            </p>
          </template>
          <template slot="classification" slot-scope="row">
            {{ row.scope.classification === 0 ? "直单" : "分单" }}
          </template>
          <template slot="blNo" slot-scope="row">
            {{
              row.scope.classification === 0 &&
                row.scope.blNo === row.scope.mblNo
                ? ""
                : row.scope.blNo
            }}
          </template>
          <!-- <template slot="mblNo" slot-scope="row">
            <p>
              <span
                class="pickUpType"
                :class="`pickUpType0`"
              >
                主单号
              </span>
              {{ row.scope.mblNo }}
            </p>
            <p>
              <span
                class="pickUpType"
                :class="`pickUpType1`"
              >
                分单号
              </span>
              {{ row.scope.blNo }}
            </p>
          </template> -->
          <template slot="ETD" slot-scope="row">
            <p
              v-for="(filed, $i) in useFildList.find((a) => a.filed === 'ETD')
                ?.multipleParameters"
              :key="$i"
            >
              <span class="pickUpType" :class="`pickUpType${$i}`">
                {{ filed.key }}
              </span>
              {{ row.scope[filed.value] | dateFilete(0) }}
            </p>
          </template>
          <template slot="ETA" slot-scope="row">
            <p
              v-for="(filed, $i) in useFildList.find((a) => a.filed === 'ETA')
                ?.multipleParameters"
              :key="$i"
            >
              <span class="pickUpType" :class="`pickUpType${$i}`">
                {{ filed.key }}
              </span>
              {{ row.scope[filed.value] | dateFilete(0) }}
            </p>
          </template>
          <template slot="puDate" slot-scope="row">
            <div style="display: flex">
              <div style="width: 160px">
                <p
                  v-for="(filed, $i) in useFildList.find(
                    (a) => a.filed === 'puDate',
                  )?.multipleParameters"
                  :key="$i"
                >
                  <span
                    class="pickUpType"
                    :class="`pickUpType${$i}`"
                    style="width: 60px"
                  >
                    {{ filed.key }}
                  </span>
                  {{ row.scope[filed.value] }}
                </p>
                <!-- <p>
                  <span
                    class="pickUpType"
                    :class="`pickUpType0`"
                  >
                    PICK UP#
                  </span>
                  {{ row.scope.puNo }}
                </p>
                <p>
                  <span
                    class="pickUpType"
                    :class="`pickUpType1`"
                  >
                    PU# 日期
                  </span>
                  {{ row.scope.puDate }}
                </p> -->
              </div>
              <i
                class="el-icon-edit"
                title="修改"
                style="
                  color: rgb(18, 88, 188);
                  cursor: pointer;
                  line-height: 55px;
                "
                @click="
                  dialogVisible17 = true;
                  rowData = row.scope;
                "
              />
            </div>
          </template>
          <template slot="originHarborName" slot-scope="row">
            <p
              v-for="(filed, $i) in useFildList.find(
                (a) => a.filed === 'originHarborName',
              )?.multipleParameters"
              :key="$i"
            >
              <span
                class="pickUpType"
                :class="`pickUpType${$i}`"
                style="width: 36px"
              >
                {{ filed.key }}
              </span>
              {{ row.scope[filed.value] }}
            </p>
          </template>
          <template slot="weightKgs" slot-scope="row">
            <p
              v-for="(filed, $i) in useFildList.find(
                (a) => a.filed === 'weightKgs',
              )?.multipleParameters"
              :key="$i"
            >
              <span
                class="pickUpType"
                :class="`pickUpType${$i}`"
                style="width: 60px"
              >
                {{ filed.key }}
              </span>
              {{ row.scope[filed.value] }}
            </p>
          </template>
          <template slot="anDate" slot-scope="row">
            <p
              v-for="(filed, $i) in useFildList.find(
                (a) => a.filed === 'anDate',
              )?.multipleParameters"
              :key="$i"
            >
              <span class="pickUpType" :class="`pickUpType${$i}`">
                {{ filed.key }}
              </span>
              {{ row.scope[filed.value] | dateFilete(0) }}
            </p>
          </template>
          <template slot="customerHanders" slot-scope="row">
            <p
              v-for="(filed, $i) in useFildList.find(
                (a) => a.filed === 'customerHanders',
              )?.multipleParameters"
              :key="$i"
            >
              <span class="pickUpType" :class="`pickUpType${$i}`">
                {{ filed.key }}
              </span>
              {{ row.scope[filed.value] }}
            </p>
          </template>
          <template slot="importerName" slot-scope="row">
            {{ row.scope.importerName }}
            <span
              v-if="row.scope.importerName"
              class="tips-import"
              :class="!row.scope.importerPermission ? 'tips-owner' : 'tips-out'"
            >
              {{ !row.scope.importerPermission ? "内部" : "外部" }}
            </span>
          </template>
          <template slot="releaseDate" slot-scope="row">
            {{ row.scope.releaseDate | dateFilete(0) }}
          </template>
          <template v-if="row.scope.containers && row.scope.containers.length > 0" slot="containers" slot-scope="row">
            <p
              v-for="(container, $i) in row.scope.containers"
              :key="$i"
            >
              <span
                class="pickUpType"
                :class="`pickUpType${$i}`"
                style="width: 40px"
              >
                柜号
              </span>
              {{ container.containerNumber }}
              <span
                style="    color: #35ba83;
    background: rgba(53, 186, 131, 0.1);
    display: inline-block;
    width: auto;
    height: 20px;
    padding: 0 10px;">{{ container.containertype }}</span>
            </p>
          </template>
          <template slot="fileCount" slot-scope="row">
            <span
              style="
                color: #1258bc;
                text-decoration: underline;
                cursor: pointer;
              "
              @click="uploadAttachment(row.scope)"
            >{{ row.scope.fileCount }}</span
            >
          </template>
          <template slot="terminalAppointmentDate" slot-scope="row">
            <p
              v-for="(filed, $i) in useFildList.find(
                (a) => a.filed === 'terminalAppointmentDate',
              )?.multipleParameters"
              :key="$i"
            >
              <span
                class="pickUpType"
                :class="`pickUpType${$i}`"
                style="width: 72px"
              >
                {{ filed.key }}
              </span>
              {{ row.scope[filed.value] }}
            </p>
          </template>
          <template slot="dischargeDate" slot-scope="row">
            <p
              v-for="(filed, $i) in useFildList.find(
                (a) => a.filed === 'dischargeDate',
              )?.multipleParameters"
              :key="$i"
            >
              <span
                class="pickUpType"
                :class="`pickUpType${$i}`"
                style="width: 60px"
              >
                {{ filed.key }}
              </span>
              <template
                v-if="filed === 'dischargeDate' || filed === 'availableDate'"
              >
                {{ row.scope[filed.value] | dateFilete(0) }}
              </template>
              <template v-else>
                {{ row.scope[filed.value] }}
              </template>
            </p>
          </template>
          <template slot="picArrivedDate" slot-scope="row">
            <p>
              <span class="pickUpType" :class="`pickUpType0`"> 到仓日期 </span>
              {{ row.scope.picArrivedDate | dateFilete(0) }}
            </p>
            <p>
              <span class="pickUpType" :class="`pickUpType1`"> 出仓日期 </span>
              {{ row.scope.firstDepartureDate | dateFilete(0) }}
            </p>
          </template>
          <template slot="isfStatus" slot-scope="row">
            <!-- <template v-if="row.scope.isfStatus">
            </template> -->
            <span :style="{ color: row.scope.isfStatus ? '' : '#FE453D' }">{{
              row.scope | formatterIsfStatus
            }}</span>
          </template>
          <template slot="isUploadMBLFile" slot-scope="row">
            <span
              :style="{
                color: row.scope.isUploadMBLFile ? '#666666' : '#FEAA4F',
              }"
            >{{ row.scope.isUploadMBLFile ? "已上传" : "未上传" }}</span
            >
          </template>
          <template slot="clearenceType" slot-scope="row">
            <p style="display: flex; justify-content: space-between">
              <span>
                <span
                  class="clearenceType"
                  :class="`clearenceType${row.scope.clearenceType}`"
                >{{
                    config.clearenceTypeOptions.find(
                      (a) => a.value === row.scope.clearenceType,
                    )?.label
                }}
                </span>
                <span v-if="row.scope.clearenceSupplier" class="supplier">{{
                  row.scope.clearenceSupplier
                }}</span>
              </span>
              <span
                v-if="showGGT(row.scope)"
                class="push"
                style="color: #9d67fe"
                @click="ggt(row.scope)"
              >
                <svg-icon className="icon" iconClass="push" />
                推送
              </span>
            </p>
          </template>
          <template slot="pickUpType" slot-scope="row">
            <p style="display: flex; justify-content: space-between">
              <span>
                <span
                  class="pickUpType"
                  :class="`pickUpType${row.scope.pickUpType}`"
                >{{
                    config.pickUpTypeOptions.find(
                      (a) => a.value === row.scope.pickUpType,
                    )?.label
                }}
                </span>
                <span v-if="row.scope.pickUpSupplier" class="supplier">{{
                  row.scope.pickUpSupplier
                }}</span>
              </span>
              <!-- <span
                v-if="showFMS(row.scope, 0)"
                class="push"
                :style="{
                  color: row.scope.pickUpType === 1 ? '#FF7444' : '#FEAA4F',
                  'border-color':
                    row.scope.pickUpType === 1 ? '#FF7444' : '#FEAA4F',
                }"
                @click="fms(row.scope)"
              >
                <svg-icon className="icon" iconClass="push" />
                FMS
              </span>
              <span v-else-if="row.scope.isPushFMS">
                <span
                  class="push"
                  :style="{
                    color: row.scope.pickUpType === 1 ? '#FF7444' : '#FEAA4F',
                    'border-color':
                      row.scope.pickUpType === 1 ? '#FF7444' : '#FEAA4F',
                  }"
                  @click="fms(row.scope)"
                >
                  重推FMS
                </span>
                <span
                  style="cursor: pointer; margin-left: 5px"
                  :style="{
                    color: row.scope.pickUpType === 1 ? '#FF7444' : '#FEAA4F',
                  }"
                  @click="fmsRemark(row.scope)"
                >
                  <svg-icon className="icon" iconClass="log" />
                  记录
                </span>
              </span> -->
            </p>
          </template>
          <template slot="supplierUnstuffingName" slot-scope="row">
            <p style="display: flex; justify-content: space-between">
              <span>
                <span
                  v-if="row.scope.supplierUnstuffingName"
                  class="supplier"
                >{{ row.scope.supplierUnstuffingName }}</span
                >
              </span>
            </p>
          </template>
          <template slot="dischargeHarborDate" slot-scope="row">
            {{ row.scope.dischargeHarborDate | dateFilete(0) }}
          </template>
          <template slot="emptyReturnedDate" slot-scope="row">
            {{ row.scope.emptyReturnedDate | dateFilete(0) }}
          </template>
          <template slot="clearenceStatus" slot-scope="row">
            <span v-if="row.scope.clearenceStatus" class="supplier">{{
              config.clearenceStatusOptions.find(
                (a) => a.value === row.scope.clearenceStatus,
              )?.label
            }}</span>
          </template>
          <template slot="pickUpSplitDeliveryStatus" slot-scope="row">
            <span class="supplier">{{
              config.departureStatusOptions.find(
                (a) => a.value === row.scope.pickUpSplitDeliveryStatus,
              )?.label
            }}</span>
          </template>
          <template slot="remark1" slot-scope="row">
            <p
              style="
                max-width: 80px;
                display: inline-block;
                overflow: hidden;
                vertical-align: bottom;
              "
            >
              {{ row.scope.remark1 }}
            </p>
            <i class="el-icon-edit" @click="editRemark(row.scope)" />
          </template>
          <template slot="remark" slot-scope="row">
            {{ row.scope.remark }}
            <i class="el-icon-edit" @click="editRemark(row.scope)" />
          </template>
          <template slot="opt" slot-scope="row">
            <el-tooltip
              :ref="`popover${row.scope.id}`"
              placement="bottom-start"
              popper-class="pop-table-opt"
              width="114"
              trigger="click"
              effect="light"
            >
              <div slot="content" class="table-opt">
                <template
                  v-for="(item, $index) in config.billShipOptOptions[
                    activeName === '' ? 0 : activeName + 1
                  ]"
                >
                  <el-button
                    v-if="item?.vIf && item?.vIf(row.scope)"
                    v-show="computedPermissions(item.name)"
                    :key="$index"
                    :v-permissson="computedPermissions(item.name)"
                    class="opt-item"
                    :class="[
                      row.scope.hasNewFollowUp ? item?.class?.newMessage : '',
                    ]"
                    :disabled="
                      item?.disabledFun &&
                      item?.disabledFun(row.scope) &&
                      'disabled'
                    "
                    @click="
                      optClickEvent(
                        item?.event?.eventName,
                        row.scope,
                        item?.event?.options,
                      )
                    "
                  >
                    {{ item.name }}
                  </el-button>
                </template>
              </div>
              <img
                style="
                  margin-left: -14px;
                  width: 16px;
                  height: 16px;
                  cursor: pointer;
                "
                src="@/assets/images/table/opt.png"
              />
            </el-tooltip>
          </template>
          <template slot="custom-total">
            <div class="custom-total">
              <div
                v-if="activeName === 0"
                class="batchPayment flex_c_c"
                @click="checkAllBill"
              >
                <img src="@/assets/images/bill/order-list.png" />批量确认
              </div>
              <div
                v-if="activeName > 0"
                class="batchPayment flex_c_c"
                @click="dialogVisible12 = true"
              >
                <img src="@/assets/images/bill/order-list.png" />附件批量上传
              </div>
            </div>
          </template>
        </base-table>
      </template>
      <template v-if="showForecast">
        <InvoiceTable
          v-loading="invoiceloading"
          :editData="forecastData"
          :row="rowData"
          :mdlType="rowData.type"
          :height="height"
          @cancel="cancel"
          @save="save"
          @ok="ok3"
        ></InvoiceTable>
      </template>
    </div>
    <CustomerListDialog
      :dialogVisible="dialogVisible"
      :useFildList="useFildListForTab"
      :useLogId="useLogId"
      :tabCode="tabCode"
      :tableCode="tabelCode"
      @ok="ok"
      @cancel="dialogVisible = false"
    ></CustomerListDialog>
    <follow-up-records-drawer
      :drawer="drawer"
      :rowData="rowData"
      :showFinance="false"
      :bill-type="rowData.status === 2 ? 1 : 0"
      @close="drawer = false"
    ></follow-up-records-drawer>
    <sure-refuse-bill-dialog
      :dialogVisible="dialogVisible1"
      :dialogType="checkBillType"
      :priorityList="priorityList"
      :shipperName="rowData.shipperName"
      :mblIds="selection.map((a) => a.id)"
      :companyId="rowData.companyId"
      @ok="ok2"
      @cancel="dialogVisible1 = false"
    ></sure-refuse-bill-dialog>
    <DetailDrawer
      :drawer="drawer2"
      :billType="billType"
      :rowData="rowData"
      @close="drawer2 = false"
    ></DetailDrawer>
    <UploadAttachmentDialog
      :dialogVisible="dialogVisible2"
      :diaLogType="0"
      :rowData="rowData"
      @ok="ok4"
      @close="dialogVisible2 = false"
    ></UploadAttachmentDialog>
    <AppointmentDialog
      :dialogVisible="dialogVisible3"
      :rowData="rowData"
      @cancel="dialogVisible3 = false"
      @ok="ok2"
    >
    </AppointmentDialog>
    <ArriveWarehouseDialog
      :dialogVisible="dialogVisible4"
      :rowData="rowData"
      @cancel="dialogVisible4 = false"
      @ok="ok2"
    >
    </ArriveWarehouseDialog>
    <OutWarehouseDialog
      :dialogVisible="dialogVisible5"
      :rowData="rowData"
      @cancel="dialogVisible5 = false"
      @ok="ok2"
    >
    </OutWarehouseDialog>
    <DateTimeDialog
      :dialogVisible="dialogVisible6"
      :type="dateTimeType"
      @ok="dateTimeOk"
      @close="dialogVisible6 = false"
    >
    </DateTimeDialog>
    <CheckTrackDrawer
      :drawer="dialogVisible7"
      :type="trackType"
      :rowData="rowData"
      :billType="billType"
      @close="dialogVisible7 = false"
    >
    </CheckTrackDrawer>
    <GGTDrawer
      :drawer="drawer3"
      :mblId="rowData.id"
      :billNo="rowData.blNo"
      :rowData="rowData"
      @close="drawer3 = false"
    >
    </GGTDrawer>
    <HoldDialog
      :dialogVisible="dialogVisible8"
      @ok="dateTimeOk"
      @cancel="dialogVisible8 = false"
    >
    </HoldDialog>
    <PushFmsDialog
      :dialogVisible="dialogVisible9"
      :mblId="rowData.id"
      :pickUpType="rowData.pickUpType"
      :qty="rowData.qty"
      @ok="ok2"
      @cancel="dialogVisible9 = false"
    >
    </PushFmsDialog>
    <RejectBillDialog
      :dialogVisible="dialogVisible10"
      :mblId="rowData.id"
      @ok="ok2"
      @cancel="dialogVisible10 = false"
    >
    </RejectBillDialog>
    <FmsFollowUpListDrawer
      :drawer="drawer4"
      :rowData="rowData"
      @close="drawer4 = false"
    >
    </FmsFollowUpListDrawer>
    <LoadOrderDrawer
      :drawer="drawer5"
      :rowData="rowData"
      @close="drawer5 = false"
    >
    </LoadOrderDrawer>
    <AuditDialog
      :dialogVisible="dialogVisible11"
      :rowData="rowData"
      @cancel="dialogVisible11 = false"
      @ok="generate"
    ></AuditDialog>
    <BatchFileUploadDialog
      :dialogVisible="dialogVisible12"
      @cancel="dialogVisible12 = false"
    ></BatchFileUploadDialog>
    <!-- <UploadMainfastDialog
      :dialogVisible="dialogVisible13"
      :rowData="rowData"
      @ok="ok5"
      @cancel="dialogVisible13 = false"
    ></UploadMainfastDialog> -->
    <AssignFollowersDialog
      :dialogVisible="dialogVisible14"
      :rowData="rowData"
      @ok="ok2"
      @cancel="dialogVisible14 = false"
    ></AssignFollowersDialog>
    <UpdateDetailDrawer
      :rowData="rowData"
      :drawer="drawer6"
      @close="drawer6 = false"
      @ok="
        drawer6 = false;
        getList(pagerConfig);
      "
    >
    </UpdateDetailDrawer>
    <UnknowProductDialog
      :dialogVisible="dialogVisible15"
      :rowData="rowData"
      :productData="productData"
      @ok="
        dialogVisible15 = false;
        getList(pagerConfig);
      "
      @cancel="dialogVisible15 = false"
    >
    </UnknowProductDialog>
    <UpdateRemarkDialog
      :dialogVisible="dialogVisible16"
      :rowData="rowData"
      @ok="
        dialogVisible16 = false;
        getList(pagerConfig);
      "
      @cancel="dialogVisible16 = false"
    >
    </UpdateRemarkDialog>
    <PuDateDialog
      :dialogVisible="dialogVisible17"
      :rowData="rowData"
      @ok="
        dialogVisible17 = false;
        getList(pagerConfig);
      "
      @cancel="dialogVisible17 = false"
    >
    </PuDateDialog>
    <UploadMainfastDialog
      v-if="dialogVisible13"
      :dialogVisible="dialogVisible13"
      :rowData="rowData"
      @ok="ok6"
      @cancel="dialogVisible13 = false"
    >
    </UploadMainfastDialog>
    <EditForecaseDrawer
      :drawer="drawer7"
      :rowData="rowData"
      :mblType="0"
      @ok="ok5"
      @close="drawer7 = false"
    >
    </EditForecaseDrawer>
    <ClearanceDetailDialog
      :dialogVisible="dialogVisible18"
      :rowData="rowData"
      @cancel="dialogVisible18 = false"
    >
    </ClearanceDetailDialog>
  </div>
</template>

<script>
import { permissions } from '@/utils/common'
const BaseFilter = () => import('@/components/filter/BaseFilter')
const SelectFilter = () => import('@/components/filter/SelectFilter')
const BaseMutiInput = () => import('@/components/base/BaseMutiInput')
const InvoiceTable = () => import('@/components/table/InvoiceTable')
const CustomerListDialog = () =>
  import('@/components/dialog/CustomerListDialog.vue')
const BaseTable = () => import('@/components/table/BaseTable.vue')
const FollowUpRecordsDrawer = () =>
  import('@/components/drawer/FollowUpRecordsDrawer')
const EditForecaseDrawer = () =>
  import('@/components/drawer/EditForecaseDrawer')
import config from '@/utils/config'

// import { getRecentMonthDate } from '@/utils/common'
import {
  getMBLPageList,
  getMBLPriorityList,
  // getMBLProduct,
  saveMBLProduct,
  forecastAccepted,
  arrivedAndDischarge,
  reservationArrived,
  mblFinished,
  realeaseMBL,
  voidMBL,
  restoreMBL,
  deleteMBL,
  revertT11ToDraft,
  // manifestDetail,
  // manifestAccepted,
  getMBLDetail
} from '@/api/bill'
import { getSysTableUser, getSaleList, getUserForType } from '@/api/system'
import { getTaxRateList, getAddressBookDrapdown } from '@/api/basic'

import SureRefuseBillDialog from './components/SureRefuseBillDialog.vue'
import DetailDrawer from './components/DetailDrawer.vue'
import UploadAttachmentDialog from './components/UploadAttachmentDialog.vue'
import AppointmentDialog from './components/AppointmentDialog.vue'
import ArriveWarehouseDialog from './components/ArriveWarehouseDialog.vue'
import PushFmsDialog from './components/PushFmsDialog.vue'
import OutWarehouseDialog from './components/OutWarehouseDialog.vue'
import DateTimeDialog from './components/DateTimeDialog.vue'
import CheckTrackDrawer from './components/CheckTrackDrawer.vue'
import GGTDrawer from './components/GGTDrawer.vue'
import HoldDialog from './components/HoldDialog.vue'
import FmsFollowUpListDrawer from './components/FmsFollowUpListDrawer.vue'
import LoadOrderDrawer from './components/LoadOrderDrawer.vue'
import RejectBillDialog from './components/RejectBillDialog.vue'
import AuditDialog from './components/AuditDialog.vue'
import BatchFileUploadDialog from './components/BatchFileUploadDialog.vue'
// import UploadMainfastDialog from './components/UploadMainfastDialog.vue'
import AssignFollowersDialog from './components/AssignFollowersDialog.vue'
import UpdateDetailDrawer from './components/UpdateDetailDrawer.vue'
import UnknowProductDialog from './components/UnknowProductDialog.vue'
import UpdateRemarkDialog from './components/UpdateRemarkDialog.vue'
import PuDateDialog from './components/PuDateDialog.vue'
import UploadMainfastDialog from './components/UploadMainfastDialog.vue'
import ClearanceDetailDialog from './components/ClearanceDetailDialog.vue'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import axios from 'axios'
import { myMixins } from '@/mixins'
export default {
  name: 'ShipBill',
  components: {
    BaseFilter,
    BaseMutiInput,
    BaseTable,
    InvoiceTable,
    CustomerListDialog,
    FollowUpRecordsDrawer,
    SureRefuseBillDialog,
    DetailDrawer,
    UploadAttachmentDialog,
    AppointmentDialog,
    ArriveWarehouseDialog,
    OutWarehouseDialog,
    DateTimeDialog,
    CheckTrackDrawer,
    GGTDrawer,
    HoldDialog,
    PushFmsDialog,
    FmsFollowUpListDrawer,
    LoadOrderDrawer,
    SelectFilter,
    RejectBillDialog,
    AuditDialog,
    BatchFileUploadDialog,
    UploadMainfastDialog,
    AssignFollowersDialog,
    UpdateDetailDrawer,
    UnknowProductDialog,
    UpdateRemarkDialog,
    PuDateDialog,
    EditForecaseDrawer,
    ClearanceDetailDialog
  },
  filters: {
    dateFilete: function(date, type) {
      if (date && !type) {
        const newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date)
        return newDate[0]
      } else if (date && type) {
        return date.slice(0, date.length - 3)
      } else {
        return ''
      }
    },
    formatterIsfStatus(row) {
      if (row.isfStatus) {
        return config.isfStatusOptions.find((a) => a.value === row.isfStatus)
          ?.label
      } else if (row.status === 2 && row.clearenceType === 0) {
        return '已完结'
      } else {
        return '未填报'
      }
    }
  },
  mixins: [myMixins],
  data() {
    return {
      config,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      billType: 0, // 空海运类型 0：海运 1：空运   统一这里调配
      activeName: -1,
      // activeName2: 0,
      searchVal: '',
      pagerConfig: {
        pageIndex: 1,
        pageSize: 20
      },
      referenceNumber: '',
      filterList: {},
      filterListJson: [],
      filterListId: '',
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible6: false,
      dialogVisible7: false,
      dialogVisible8: false,
      dialogVisible9: false,
      dialogVisible10: false,
      dialogVisible11: false,
      dialogVisible12: false,
      dialogVisible13: false,
      dialogVisible14: false,
      dialogVisible15: false,
      dialogVisible16: false,
      dialogVisible17: false,
      dialogVisible18: false,
      checkBillType: 0,
      tabelCode: 'MBLSea', // 用户习惯空海运类型
      useLogId: '',
      height: 0,
      // tableData: {
      //   fileds: [],
      //   // fileds: [
      //   //   {
      //   //     filed: 'opt',
      //   //     label: '操作',
      //   //     width: '50px',
      //   //     isCustom: true,
      //   //     fixed: 'left'
      //   //   },
      //   //   {
      //   //     filed: 'createdOn',
      //   //     label: '创建时间',
      //   //     isCustom: true,
      //   //     width: '150px'
      //   //   },
      //   //   {
      //   //     filed: 'companyName',
      //   //     label: '客户',
      //   //     width: '150px'
      //   //   },
      //   //   {
      //   //     filed: 'transportName',
      //   //     label: '船公司',
      //   //     width: '150px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'mblNo',
      //   //     label: '提单号',
      //   //     isCopy: true,
      //   //     width: '200px'
      //   //   },
      //   //   {
      //   //     filed: 'blNo',
      //   //     label: '分单号',
      //   //     isCopy: true,
      //   //     width: '200px',
      //   //     formatter: row => {
      //   //       return row.classification === 0 && row.blNo === row.mblNo ? '' : row.blNo
      //   //     }
      //   //   },
      //   //   {
      //   //     filed: 'containerNumber',
      //   //     label: '柜号',
      //   //     isCopy: true,
      //   //     width: '150px'
      //   //   },
      //   //   {
      //   //     filed: 'containerType',
      //   //     label: '柜型',
      //   //     width: '100px'
      //   //   },
      //   //   {
      //   //     filed: 'isfStatus',
      //   //     label: 'ISF状态',
      //   //     width: '100px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'etdeta',
      //   //     label: '开船日期',
      //   //     width: '160px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'dischargeHarborDate',
      //   //     label: '到卸货港日期',
      //   //     width: '120px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'etaata',
      //   //     label: '到港日期',
      //   //     width: '160px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'puNumber',
      //   //     label: 'PU#日期',
      //   //     width: '200px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'port',
      //   //     label: '港口信息',
      //   //     width: '250px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'billInfo',
      //   //     label: '提单信息',
      //   //     width: '160px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'ando',
      //   //     label: 'AN/DO日期',
      //   //     width: '160px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'consigneeName',
      //   //     label: '收货人',
      //   //     width: '160px'
      //   //   },
      //   //   {
      //   //     filed: 'importerName',
      //   //     label: '进口商',
      //   //     width: '160px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'releaseDate',
      //   //     label: '放行日期',
      //   //     width: '150px',
      //   //   formatter: (row) =>
      //   //     row.releaseDate
      //   //       ? row.releaseDate.slice(0, row.releaseDate.length - 3)
      //   //       : ''
      //   //   },
      //   //   {
      //   //     filed: 'clearenceType',
      //   //     label: '清关方式',
      //   //     width: '160px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'clearenceStatusName',
      //   //     label: '清关状态',
      //   //     width: '100px'
      //   //   },
      //   //   {
      //   //     filed: 'forecastInvoiceStatusName',
      //   //     label: '预报状态',
      //   //     width: '100px'
      //   //   },
      //   //   {
      //   //     filed: 'remark',
      //   //     label: '备注',
      //   //     width: '150px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'remark1',
      //   //     label: '备注1',
      //   //     width: '150px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'pickUpType',
      //   //     label: '提货方式',
      //   //     width: '160px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'pickUpInfo',
      //   //     label: '提柜信息',
      //   //     width: '200px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'terminalNameInfo',
      //   //     label: '码头信息',
      //   //     width: '200px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'terminalName',
      //   //     label: '码头',
      //   //     width: '160px'
      //   //   },
      //   //   {
      //   //     filed: 'supplierUnstuffingName',
      //   //     label: '拆柜供应商',
      //   //     width: '160px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'picArrivedDate',
      //   //     label: '到仓/出仓日期',
      //   //     width: '160px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'emptyReturnedDate',
      //   //     label: '还空柜日期',
      //   //     width: '150px',
      //   //   formatter: (row) =>
      //   //     row.emptyReturnedDate
      //   //       ? row.emptyReturnedDate.slice(0, row.emptyReturnedDate.length - 3)
      //   //       : ''
      //   //   },
      //   //   {
      //   //     filed: 'pickUpSplitDeliveryStatusName',
      //   //     label: '提拆交状态',
      //   //     width: '100px'
      //   //   },
      //   //   {
      //   //     filed: 'shipperName',
      //   //     label: '发货人',
      //   //     width: '160px'
      //   //   },
      //   //   {
      //   //     filed: 'countryCode',
      //   //     label: '目的国家',
      //   //     width: '100px'
      //   //   },
      //   //   {
      //   //     filed: 'classification',
      //   //     label: '提单分类',
      //   //     width: '100px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'isUploadMBLFile',
      //   //     label: '提单文件',
      //   //     width: '100px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'forecastDate',
      //   //     label: '预报日期',
      //   //     width: '100px',
      //   //     isCustom: true
      //   //   },
      //   //   {
      //   //     filed: 'customerHanders',
      //   //     label: '客服负责人',
      //   //     width: '150px'
      //   //   },
      //   //   {
      //   //     filed: 'operatorHanders',
      //   //     label: '操作负责人',
      //   //     width: '150px'
      //   //   },
      //   //   {
      //   //     filed: 'saleName',
      //   //     label: '销售员',
      //   //     width: '100px'
      //   //   }
      //   // ],
      //   mutiCheck: true,
      //   columns: [],
      //   total: 0,
      //   tableRowClassName({ row }) {
      //     if (row.apiUpdateOn) {
      //       return 'api-update'
      //     } else {
      //       return ''
      //     }
      //   }
      // },
      useFildList: [],
      loading: false,
      invoiceloading: false,
      isActive: false,
      drawer: false,
      drawer2: false,
      drawer3: false,
      drawer4: false,
      drawer5: false,
      drawer7: false,
      tableResData: {
        columns: [],
        total: 0
      },
      rowData: {},
      sortable: {},
      priorityList: [],
      pickUpOptions: [],
      clearenceOptions: [],
      userOptions: [],
      destinationOptions: [],
      shipTransportOptions: [],
      originOptions: [],
      customerOptions: [],
      operatorOptions: [],
      tabNumer: [],
      selection: [],
      productData: [], // 未识别的产品数据
      drawer6: false,
      fillType: 0, // 7 税金单
      showForecast: false, // 是否显示预报页面
      forecastData: [], // 预报数据
      dateTimeType: '到港', // 到港和卸船弹窗类型
      trackType: 0, // 查看轨迹类型
      contanierLoading: false, // 用来加载页面按钮
      activeCode: ''
    }
  },
  computed: {
    ...mapGetters(['billShipTabNumber', 'companyDrapdown']),
    tabCode() {
      return `${
        this.activeName !== ''
          ? this.config.billStatusOptions.find(
              (a) => a.value === this.activeName,
            )?.permissson
          : 'QB'
      }-All`
    },
    permissson() {
      return this.config.billStatusOptions.find(
        (a) => a.value === this.activeName,
      )?.permissson
    },
    useFildListForTab() {
      const arr = this.useFildList.filter(
        (a) =>
          a.selected === true &&
          (a.tabCode === this.tabCode || a.tabCode === null),
      )
      if (arr.length > 0) {
        return arr
      } else {
        // 说明是新加的tab 页面 且 没有用户习惯
        return this.useFildList
      }
    },
    companyOptions() {
      return this.companyDrapdown
    },
    computedPermissions() {
      return function(key) {
        const menuList = this.$store.getters.initRouter
        const menu = permissions(this.$route.meta.code, menuList)
        const presentTab = menu.children.find(
          (a) => a.code === this.activeCode,
        )
        const code = presentTab?.children?.find((a) => a.nameCH === key)?.code
        return code || ''
      }
    },
    tableData() {
      // if (this.tableResData.columns.length === 0) {
      //   return {}
      // }
      const isCustomArr = [
        'createdOn',
        'transportName',
        'ETD',
        'blNo',
        'isfStatus',
        'dischargeHarborDate',
        'ETA',
        'puDate',
        'originHarborName',
        'weightKgs',
        'anDate',
        'importerName',
        'releaseDate',
        'clearenceType',
        'remark',
        'remark1',
        'terminalAppointmentDate',
        'dischargeDate',
        'emptyReturnedDate',
        'classification',
        'isUploadMBLFile',
        'customerHanders',
        'pickUpType',
        'fileCount',
        'containers'
      ]
      const isSortArr = [
        'ETA',
        'ETD',
        'ATA',
        'ATD',
        'dischargeDate',
        'releaseDate',
        'terminalAppointmentDate',
        'picPickUpDate',
        'emptyReturnedDate',
        'forecastDate',
        'availableDate',
        'createdOn'
      ]
      const isCopy = ['mblNo', 'blNo', 'containerNumber']
      const isAlign = ['mblNo', 'blNo']
      const newArr = this.useFildListForTab.map((item) => {
        return {
          filed: item.filed,
          label: item.label,
          width: item.width,
          isSort: isSortArr.indexOf(item.filed) > -1, // 是否支持过滤
          align: isAlign.indexOf(item.filed) > -1 && 'left',
          fixed: item.isFixed, // 是否固定 true, left, right
          isCustom: isCustomArr.indexOf(item.filed) > -1, // 是否自定义列显示
          isCopy: isCopy.indexOf(item.filed) > -1
        }
      })
      // if (parseInt(this.activeName, 10) >= 2 || this.activeName === '') {
      //   newArr.push({
      //     filed: 'picArrivedDate',
      //     label: '到仓时间',
      //     width: '170',
      //     formatter: (row) =>
      //       row.picArrivedDate
      //         ? row.picArrivedDate.slice(0, row.picArrivedDate.length - 3)
      //         : ''
      //   })
      //   newArr.push({
      //     filed: 'firstDepartureDate',
      //     label: '出仓时间',
      //     width: '170',
      //     formatter: (row) =>
      //       row.firstDepartureDate
      //         ? row.firstDepartureDate.slice(
      //             0,
      //             row.firstDepartureDate.length - 3
      //           )
      //         : ''
      //   })
      // }
      newArr.unshift({
        filed: 'opt',
        label: '',
        // width: optWidth[this.activeName2],
        width: '50px',
        fixed: 'left',
        isCustom: true
      })
      // newArr.push({
      //   filed: 'opt',
      //   label: '操作',
      //   width: optWidth[this.activeName2],
      //   isCustom: true,
      //   fixed: 'right'
      // })
      return {
        fileds: newArr,
        ...this.tableResData,
        mutiCheck: true
      }
    },
    allTotal() {
      return this.tabNumer
        ? this.tabNumer.reduce((prev, next) => {
            return (prev += next.qty)
          }, 0)
        : 0
    }
  },
  watch: {
    '$store.state.connect.connect': {
      handler: function(query) {
        if (query.menuCode === 'HYTD') {
          const json = JSON.parse(query.queryJson)
          this.activeName = json.queryParam.status
          // this.activeName2 = json.queryParam.subStatus
          this.searchVal = json.queryParam.mblNo.join(',')
          this.referenceNumber = json.queryParam.mblNo
          console.log('this.referenceNumber', this.referenceNumber)
          // 重置filter
          const param = {
            pageIndex: 1,
            pageSize: 20
          }
          this.pagerConfig = param
          this.filterList = {
            date: '',
            companyId: [],
            supplierClearenceIds: [],
            pickUpSupplierIds: [],
            destinationHarborCodes: [],
            originHarborCodes: [],
            saleIds: [],
            classification: ''
          }
          this.getUserUseLog()
        }
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    // this.filterList.date = getRecentMonthDate(1)
    this.getUserUseLog()
    // this.getPriorityList()
    this.getUserList()
    if (!this.companyDrapdown.length) {
      this.$store.dispatch('getCompanyDrapdown')
    }

    const pickUpOptions = await this.$store.dispatch(
      'getSupplierDropDownList',
      { scopValue: 19 },
    )
    this.pickUpOptions = pickUpOptions
    const clearenceOptions = await this.$store.dispatch(
      'getSupplierDropDownList',
      { scopValue: 18 },
    )
    this.clearenceOptions = clearenceOptions
    const destinationOptions = await this.$store.dispatch('getHarborDrapDown', {
      portType: 1,
      type: 1
    })
    this.destinationOptions = destinationOptions
    const originOptions = await this.$store.dispatch('getHarborDrapDown', {
      portType: 1,
      type: 0
    })
    this.originOptions = originOptions
    if (!(this.shipTransportOptions && this.shipTransportOptions.length > 0)) {
      await this.$store.dispatch('getShipTransportOptions')
    }
    this.getFilter()
    this.getUserForType()
  },
  mounted() {
    this.height = document.querySelectorAll('.data')[0].offsetHeight - 42
    window.addEventListener('resize', () => {
      this.height = document.querySelectorAll('.data')[0].offsetHeight - 42
    })
    if (!this.$store.state.connect.connect.menuCode) {
      const menuList = this.$store.getters.initRouter
      const menu = permissions(this.$route.meta.code, menuList)
      const codeList = ['QB', 'DCL', 'QGZ', 'YC', 'WJ']
      const childrenCode = menu.children.map((a) => a.code)
      const codeIndex = codeList.findIndex((a) => childrenCode.includes(a))
      this.activeCode = menu.children[0].code
      this.activeName = codeIndex ? codeIndex - 1 : ''
      // 挂载后要给子Tab赋值  防止按钮权限导致的activeName2默认值还是'0'
      // const activeName2List = ['0', '2', '9']
      // this.activeName2 =
      //   this.activeName !== ''
      //     ? +activeName2List.find((a, i) => i === +this.activeName)
      //     : undefined
    }
  },
  beforeDestroy() {
    this.$store.dispatch('setEmptyConnect')
  },
  methods: {
    handleClick(type, value, code) {
      this.activeCode = code
      let flag = false
      if (this.activeName !== value) {
        flag = true
      }
      this.activeName = value
      // this.activeName2 =
      //   this.activeName !== ''
      //     ? this.config.billShipSubtabOptions[this.activeName][0].value
      //     : undefined
      this.tabelHeight()
      const param = {
        pageIndex: 1,
        pageSize: this.pagerConfig.pageSize
      }
      this.selectionItem = []
      this.pagerConfig = param
      flag && this.getUserUseLog()
      // this.$refs.baseMutiInput.reset()
      // this.referenceNumber = ''
      // this.searchVal = ''
    },
    tabelHeight() {
      if (this.activeName === '' || this.activeName === 4) {
        this.height = document.querySelector('.data').offsetHeight + 6
      } else if (this.activeName === 1 && this.showForecast) {
        this.height = document.querySelector('.data').offsetHeight - 160
      }
    },
    handleFocus() {
      this.$refs.popover.doShow()
    },
    closeSearchPanel() {
      this.handleConfirm()
    },
    handleConfirm() {
      // mousedown 早于 change 执行 所以延时  如果用click则 change后不执行代码
      setTimeout(() => {
        if (this.referenceNumber && this.referenceNumber !== '') {
          this.searchVal = this.referenceNumber.join(';')
        }
        this.$refs.popover.doClose()
        // todo 重置filter
        this.filterList = {}
        const param = {
          pageIndex: 1,
          pageSize: 20
        }
        this.pagerConfig = param
        this.isActive = false
        this.getList(param, {
          status: this.activeName !== '' ? this.activeName : undefined
          // subStatus: this.activeName2 !== '' ? this.activeName2 : undefined
        })
      }, 0)
      // this.getList(this.pagerConfig)
    },
    handleEmpty() {
      this.referenceNumber = ''
      this.searchVal = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      this.initList()
    },
    handleSelectionChange(val) {
      this.selection = val
    },
    async getPriorityList() {
      try {
        const res = await getMBLPriorityList({
          pageIndex: 1,
          pageSize: 1000
        })
        if (res.success) {
          this.priorityList = res.data.list
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error
      }
    },
    getUserList() {
      getSaleList().then((res) => {
        if (res.success) {
          const arr = []
          res.data.map((item) => {
            arr.push({
              value: item.id,
              label: item.nameCH
            })
          })
          this.userOptions = arr
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    async getUserForType() {
      try {
        const res = await getUserForType({})
        if (res.success) {
          this.customerOptions = res.data
            .filter((a) => [103, 104].includes(a.type))
            .map((item) => {
              return {
                value: item.id,
                label: item.nameCH
              }
            })
          this.operatorOptions = res.data
            .filter((a) => [99, 100].includes(a.type))
            .map((item) => {
              return {
                value: item.id,
                label: item.nameCH
              }
            })
        } else {
          this.$message.error(res.errorMessage)
        }
        // if (res.success) {
        //   this.customerOptions = res.data.map((item) => {
        //     return {
        //       value: item.id,
        //       label: item.nameCH
        //     }
        //   })
        // } else {
        //   this.$message.error(res.errorMessage)
        // }
        // const res1 = await getUserForType({ type: 100 })
        // if (res1.success) {
        //   this.operatorOptions = res1.data.map((item) => {
        //     return {
        //       value: item.id,
        //       label: item.nameCH
        //     }
        //   })
        // } else {
        //   this.$message.error(res1.errorMessage)
        // }
      } catch (error) {
        console.log(error)
      }
    },
    getList(params, filter) {
      this.loading = true
      this.$nextTick(async() => {
        try {
          // const realFilter = filter || this.formatterFilter()
          params = {
            ...params,
            queryParam: {
              ...this.sortable,
              // ...realFilter,
              type: this.billType,
              status: this.activeName !== '' ? this.activeName : undefined,
              // subStatus: this.activeName2 !== '' ? this.activeName2 : undefined,
              ...filter,
              ...this.filterList,
              mblNo: this.searchVal ? this.searchVal.split(';') : undefined
            }
          }
          const res = await getMBLPageList(params)
          if (res.success) {
            !res.data.list && (res.data.list = [])
            const newList1 = res.data.list.map((a) => {
              return {
                ...a,
                ATD: a.atd,
                ATA: a.ata,
                ETD: a.etd,
                ETA: a.eta
              }
            })
            const newList2 = newList1.filter((a) => {
              return (
                a.status === parseInt(this.activeName, 10)
                // a.subStatus === parseInt(this.activeName2, 10)
              )
            })
            const newList = this.activeName !== '' ? newList2 : newList1
            this.tableResData.columns = newList
            this.tabNumer = res.data.tabNumer
            this.tableResData.total = res.data.total
            // this.tableData.columns = newList
            // this.tabNumer = res.data.tabNumer
            // this.tableData.total = res.data.total
            this.tabelHeight()
            this.loading = false
          } else {
            this.$message.error(res.errorMessage)
          }
          // console.log(res)
        } catch (error) {
          this.loading = false
          console.error(error)
        }
      })
    },
    async getUserUseLog() {
      try {
        this.loading = true
        // this.tableResData.columns = []
        const res = await getSysTableUser({
          tableCode: this.tabelCode
          // tabCode: this.tabCode || 'QB-All'
        })
        if (res.success) {
          if (res.data && res.data.value) {
            await this.getList(this.pagerConfig)
            const filedArr = JSON.parse(res.data.value)
            this.useLogId = res.data.id
            this.useFildList = filedArr
          }
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    sendFilter() {
      const filterList = this.$refs.selectFilter.getData()
      if (Object.keys(filterList).length > 0) {
        this.isActive = true
      }
      this.filterList = filterList
      // this.initList()
      const param = {
        pageIndex: 1,
        pageSize: this.pagerConfig.pageSize
      }
      this.referenceNumber = ''
      this.searchVal = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      this.pagerConfig = param
      this.getList(param)
    },
    reset() {
      this.$refs.selectFilter.reset()
      this.isActive = false
      this.referenceNumber = ''
      this.searchVal = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
    },
    // sendFilter() {
    //   if (
    //     (this.filterList.companyId && this.filterList.companyId.length > 0) ||
    //     this.filterList.supplierClearenceIds.length > 0 ||
    //     this.filterList.pickUpSupplierIds.length > 0 ||
    //     this.filterList.destinationHarborCodes.length > 0 ||
    //     this.filterList.originHarborCodes.length > 0 ||
    //     this.filterList.saleIds.length > 0 ||
    //     this.filterList.classification !== '' ||
    //     this.filterList.date.length !== 0
    //   ) {
    //     this.isActive = true
    //   } else {
    //     this.isActive = false
    //   }
    //   const param = {
    //     pageIndex: 1,
    //     pageSize: 20
    //   }
    //   // 清空提单搜索
    //   this.pagerConfig = param
    //   this.referenceNumber = ''
    //   this.searchVal = ''
    //   this.$refs.baseMutiInput.reset()
    //   this.$refs.popover.doClose()
    //   this.getList(param, {
    //     status: this.activeName !== '' ? this.activeName : undefined,
    //     subStatus: this.activeName2 !== '' ? this.activeName2 : undefined,
    //     startTime: this.filterList.date ? this.filterList.date[0] : undefined,
    //     endTime: this.filterList.date ? this.filterList.date[1] : undefined,
    //     companyId:
    //       this.filterList.companyId && this.filterList.companyId.length > 0
    //         ? this.filterList.companyId
    //         : undefined,
    //     supplierClearenceIds:
    //       this.filterList.supplierClearenceIds &&
    //       this.filterList.supplierClearenceIds.length > 0
    //         ? this.filterList.supplierClearenceIds
    //         : undefined,
    //     pickUpSupplierIds:
    //       this.filterList.pickUpSupplierIds &&
    //       this.filterList.pickUpSupplierIds.length > 0
    //         ? this.filterList.pickUpSupplierIds
    //         : undefined,
    //     destinationHarborCodes:
    //       this.filterList.destinationHarborCodes &&
    //       this.filterList.destinationHarborCodes.length > 0
    //         ? this.filterList.destinationHarborCodes
    //         : undefined,
    //     originHarborCodes:
    //       this.filterList.originHarborCodes &&
    //       this.filterList.originHarborCodes.length > 0
    //         ? this.filterList.originHarborCodes
    //         : undefined,
    //     saleIds:
    //       this.filterList.saleIds && this.filterList.saleIds.length > 0
    //         ? this.filterList.saleIds
    //         : undefined,
    //     classification: this.filterList.classification
    //       ? this.filterList.classification
    //       : undefined
    //   })
    // },
    // reset() {
    //   this.filterList = {
    //     date: getRecentMonthDate(1),
    //     companyId: [],
    //     supplierClearenceIds: [],
    //     pickUpSupplierIds: [],
    //     destinationHarborCodes: [],
    //     originHarborCodes: [],
    //     saleIds: [],
    //     classification: ''
    //   }
    //   this.$refs.baseMutiInput.reset()
    //   this.referenceNumber = ''
    //   this.searchVal = ''
    //   this.isActive = false
    // },
    handlePageChange(pager) {
      this.pagerConfig = pager
      this.getList(pager)
    },
    sortChange(orderObj) {
      this.sortable = {
        sortField: orderObj.prop,
        sortBy: orderObj.order === 'asc' ? 0 : 1
      }
      this.getList(this.pagerConfig)
    },
    formatterFilter() {
      return {
        status: this.activeName !== '' ? this.activeName : undefined,
        // subStatus: this.activeName2 !== '' ? this.activeName2 : undefined,
        mblNo: this.searchVal ? this.searchVal.split(';') : undefined,
        startTime: this.filterList.date ? this.filterList.date[0] : undefined,
        endTime: this.filterList.date ? this.filterList.date[1] : undefined,
        type: this.billType,
        companyId:
          this.filterList.companyId && this.filterList.companyId.length > 0
            ? this.filterList.companyId
            : undefined,
        supplierClearenceIds:
          this.filterList.supplierClearenceIds &&
          this.filterList.supplierClearenceIds.length > 0
            ? this.filterList.supplierClearenceIds
            : undefined,
        pickUpSupplierIds:
          this.filterList.pickUpSupplierIds &&
          this.filterList.pickUpSupplierIds.length > 0
            ? this.filterList.pickUpSupplierIds
            : undefined,
        destinationHarborCodes:
          this.filterList.destinationHarborCodes &&
          this.filterList.destinationHarborCodes.length > 0
            ? this.filterList.destinationHarborCodes
            : undefined,
        originHarborCodes:
          this.filterList.originHarborCodes &&
          this.filterList.originHarborCodes.length > 0
            ? this.filterList.originHarborCodes
            : undefined,
        saleIds:
          this.filterList.saleIds && this.filterList.saleIds.length > 0
            ? this.filterList.saleIds
            : undefined,
        classification:
          this.filterList.classification !== ''
            ? this.filterList.classification
            : undefined
      }
    },
    initList() {
      // this.reset()
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: 20
      }
      this.getList({
        pageIndex: 1,
        pageSize: 20
      })
    },
    async dblclick(row) {
      await this.$store.dispatch('getAddressBookOptions', {
        type: -1
        // companyId: row.companyId
      })
      this.rowData = row
      this.drawer2 = true
    },
    async getFilter() {
      try {
        const res = await getSysTableUser({
          tableCode: 'MBLSea',
          type: 1
        })
        if (res.success) {
          this.filterListJson = JSON.parse(res.data.value)
          this.filterListId = res.data.id
          console.log('filterListJson', this.filterListJson)
        }
      } catch (error) {
        console.warn(error)
      }
    },
    ok1() {
      this.getFilter()
    },
    ok() {
      this.dialogVisible = false
      this.getUserUseLog()
    },
    ok2() {
      this.dialogVisible1 = false
      this.dialogVisible3 = false
      this.dialogVisible4 = false
      this.dialogVisible5 = false
      this.dialogVisible9 = false
      this.dialogVisible10 = false
      this.dialogVisible13 = false
      this.dialogVisible14 = false
      this.getList(this.pagerConfig)
    },
    async ok3({ items }) {
      this.invoiceloading = true
      // if (!this.rowData.isType86) {
      const consigneeName = this.rowData.consigneeName
      const shipperName = this.rowData.shipperName
      // 获取当前客户的地址数据
      const addressBookResult = await getAddressBookDrapdown({
        type: -1,
        companyId: this.rowData.companyId
      })
      const addressDataList = addressBookResult.data
      // 获取shipper和consignee的地址数据
      const shipper = addressDataList
        .filter((a) => a.type === 20)
        .find((a) => a.companyName === shipperName)
      const consingee = addressDataList
        .filter((a) => a.type === 20)
        .find((a) => a.companyName === consigneeName)
      const params = {
        items,
        shipper: {
          ...shipper,
          type: 2,
          addressLine: [
            shipper.addressLine1 ? shipper.addressLine1 : '',
            shipper.addressLine2 ? shipper.addressLine2 : ''
            // shipper.addressLine3 ? shipper.addressLine3 : ''
          ]
        },
        consingee: {
          ...consingee,
          type: 3,
          addressLine: [
            consingee.addressLine1 ? consingee.addressLine1 : '',
            consingee.addressLine2 ? consingee.addressLine2 : ''
            // consingee.addressLine3 ? consingee.addressLine3 : ''
          ]
        },
        mblId: this.rowData.id
      }
      try {
        const result = await forecastAccepted(params)
        if (result.success) {
          this.initList()
          this.showForecast = false
          this.$store.commit('set_empty_item')
          this.$message.success(result.errorMessage)
          this.invoiceloading = false
        } else {
          this.$message.error(result.errorMessage)
          this.invoiceloading = false
        }
      } catch (error) {
        console.error(error)
      }
      // } else {
      //   try {
      //     const params = {
      //       items,
      //       mblId: this.rowData.id
      //     }
      //     const res = await manifestAccepted(params)
      //       this.invoiceloading = false
      //     if (res.success) {
      //       this.initList()
      //       this.showForecast = false
      //       this.$message.success(res.errorMessage)
      //     } else {
      //       this.$message.error(res.errorMessage)
      //     }
      //   } catch (error) {
      //       this.invoiceloading = false
      //     console.error(error)
      //   }
      // }
    },
    ok4() {
      this.initList()
    },
    updateLog(row) {
      row.hasNewFollowUp = false
      this.rowData = row
      this.drawer = true
    },
    checkBill(row, type) {
      this.selection = [row]
      this.checkBillType = type
      this.dialogVisible1 = true
    },
    checkAllBill() {
      if (this.selection.length === 0) {
        this.$message.error('请选择要操作的记录')
        return false
      }
      const flagArr = Array.from(
        new Set(this.selection.map((a) => a.clearenceType)),
      )
      if (flagArr.length > 1) {
        this.$message.error('存在两种清关方式')
        return false
      }
      const flagModeArr = Array.from(
        new Set(this.selection.map((a) => a.clearanceMode)),
      )
      if (flagModeArr.length > 1) {
        this.$message.error('存在两种清关模式')
        return false
      }
      this.checkBillType = 0
      this.dialogVisible1 = true
    },
    uploadAttachment(row) {
      this.rowData = row
      this.dialogVisible2 = true
    },
    async generate(data, tax) {
      this.dialogVisible11 = false
      this.loading = true
      // const row = this.rowData
      try {
        // const result = await getMBLProduct({ mblId: row.id })
        // if (result.success) {
        this.forecastData = await this.getTaxRateList(data)
        this.rowData = {
          ...this.rowData,
          ...tax
        }
        this.loading = false
        this.showForecast = true
        this.height = document.querySelector('.data').offsetHeight - 120
        // } else {
        //   this.$message.error(result.errorMessage)
        // }
      } catch (error) {
        console.error(error)
      }
    },
    audit(row) {
      this.rowData = row
      this.dialogVisible11 = true
    },
    ggt(row) {
      this.rowData = row
      this.drawer3 = true
    },
    // 获取基础税率和加征税率
    async getTaxRateList(val) {
      try {
        const hsCodeArr = val.map((a) => a.hsCode).join(',')
        const result = await getTaxRateList({ hsCode: hsCodeArr })
        if (result.success) {
          const newValArr = val.map((a) => {
            const myHsCode = result.data.find((b) => b.hsCode === a.hsCode)
            if (myHsCode) {
              a.baseRate = myHsCode.baseRate
              a.addRate = myHsCode.addRate
            } else {
              a.baseRate = 0
              a.addRate = 0
            }
            return a
          })
          return Promise.resolve(newValArr)
        } else {
          this.$message.error(result.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    cancel(type) {
      if (type) {
        this.getList(this.pagerConfig)
      }
      this.showForecast = false
      this.tabelHeight()
    },
    back() {
      this.invoiceloading = false
      this.showForecast = false
      this.tabelHeight()
    },
    async save({ items }) {
      const params = {
        items,
        mblId: this.rowData.id,
        isStaged: true
      }
      try {
        const result = await saveMBLProduct(params)
        if (result.success) {
          this.$message.success('暂存成功')
          this.$store.commit('set_empty_item')
          this.showForecast = false
          this.getList(this.pagerConfig)
        } else {
          this.$message.error(result.errorMessage)
        }
        console.log(result)
      } catch (error) {
        console.error(error)
      }
    },
    optClickEvent(event, row, options) {
      this[event](row, ...options)
      // this.checkCode(code)
    },
    // async checkCode(code) {
    //   if (
    //     this.$store.state.connect.connect.btnCode &&
    //     code === this.$store.state.connect.connect.btnCode
    //   ) {
    //     this.$store.dispatch('readConnnet')
    //   }
    // },
    showDateTime(row, type) {
      this.dateTimeType = type
      this.rowData = row
      this.dialogVisible6 = true
    },
    showTrack(row, type) {
      this.trackType = type
      this.rowData = row
      this.dialogVisible7 = true
    },
    async dateTimeOk(val) {
      this.dialogVisible6 = false
      const params = {
        mblId: this.rowData.id,
        date: val,
        subStatus: this.dateTimeType === '到港' ? 101 : 102
      }
      try {
        const result = await arrivedAndDischarge(params)
        if (result.success) {
          this.getList(this.pagerConfig)
          this.$message.success(result.errorMessage)
        } else {
          this.$message.error(result.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 预约
    showAppointment(row) {
      this.rowData = row
      this.dialogVisible3 = true
    },
    // 到达
    arrive(row) {
      this.$confirm('是否确认到达', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        center: true
      })
        .then(async() => {
          try {
            const result = await reservationArrived({ mblId: row.id })
            if (result.success) {
              this.$message.success('到达成功')
              this.getList(this.pagerConfig)
            } else {
              this.$message.error(result.errorMessage)
            }
          } catch (error) {
            console.error(error)
          }
        })
        .catch(() => {})
    },
    // 到仓出仓
    async showWarehouse(row, type) {
      this.rowData = row
      type === '0' && (this.dialogVisible4 = true)
      type === '1' && (this.dialogVisible5 = true)
    },
    // 推送fms
    fms(row) {
      this.rowData = row
      this.dialogVisible9 = true
    },
    // fms跟进记录
    fmsRemark(row) {
      this.rowData = row
      this.drawer4 = true
    },
    // 完结
    async over(row) {
      try {
        const res = await getMBLDetail({ mblId: row.id })
        if (res.success) {
          // const depaturedQty = res.data?.pickUp?.depaturedQty
          // if (depaturedQty === row.qty || row.pickUpType === 0) {
          const result = await mblFinished({ mblId: row.id })
          if (result.success) {
            this.getList(this.pagerConfig)
            this.$message.success(result.errorMessage)
          } else {
            this.$message.error(result.errorMessage)
          }
          // } else {
          //   this.$confirm(
          //     `出仓件数：${depaturedQty}不等于提单件数：${row.qty}, 是否继续`,
          //     '提示',
          //     {
          //       confirmButtonText: '确定',
          //       cancelButtonText: '取消',
          //       iconClass: 'warning',
          //       showClose: false,
          //       closeOnPressEscape: false,
          //       closeOnClickModal: false,
          //       center: true
          //     }
          //   )
          //     .then(async() => {
          //       const result = await mblFinished({ mblId: row.id })
          //       if (result.success) {
          //         this.getList(this.pagerConfig)
          //         this.$message.success(result.errorMessage)
          //       } else {
          //         this.$message.error(result.errorMessage)
          //       }
          //     })
          //     .catch(() => {})
          // }
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async batchExport() {
      const filter = {
        ...this.sortable,
        // ...realFilter,
        type: this.billType,
        status: this.activeName !== '' ? this.activeName : undefined,
        // subStatus: this.activeName2 !== '' ? this.activeName2 : undefined,
        ...this.filterList,
        mblNo: this.searchVal ? this.searchVal.split(';') : undefined
      }
      filter.tabCode = this.tabCode
      filter.mblNo =
        this.selection.length > 0
          ? this.selection.map((a) => a.mblNo)
          : filter.mblNo
      const date1 = dayjs(filter.endTime)
      if (date1.diff(filter.startTime, 'months') > 6) {
        this.$message.warning('最多下载6个月数据')
        return
      }
      this.contanierLoading = true
      try {
        const res = await axios({
          url: `/api/MBL/exportMBLList`,
          method: 'post',
          responseType: 'blob',
          withCredentials: true,
          headers: {
            ESCLEARANCE: btoa(`BC5BC301345F4D57CC1A8EF1F74579A7&${Date.now()}`),
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(filter)
        })
        const fileName = window
          .decodeURI(res.headers['content-disposition'].split('=')[2], 'UTF-8')
          .replace(`UTF-8''`, '')
        const filestream = res.data // 返回的文件流
        const blob = new Blob([filestream], {
          type: 'application/vnd.ms-excel'
        })
        const a = document.createElement('a')
        const href = window.URL.createObjectURL(blob) // 创建下载连接
        a.href = href
        a.download = fileName
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a) // 下载完移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
        this.contanierLoading = false
      } catch (error) {
        this.contanierLoading = false
        console.log(error)
      }
    },
    hold() {
      this.dialogVisible8 = true
    },
    async release(row) {
      try {
        const res = await realeaseMBL({ mblId: row.id })
        if (res.success) {
          this.$message.success('release成功')
          this.getList(this.pagerConfig)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 装载
    async loadOrder(row) {
      this.$store
        .dispatch('getAddressBookOptions', {
          type: -1,
          companyId: row.companyId
        })
        .then(() => {
          this.rowData = row
          this.drawer5 = true
        })
    },
    // 驳回
    rejectdAttachment(row) {
      this.rowData = row
      this.dialogVisible10 = true
    },
    async handleVoid(row) {
      this.$confirm('确定作废，提单状态将到“异常-作废”', '是否确定作废？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        center: true
      })
        .then(async() => {
          try {
            let res
            if (row.clearanceMode === 2) {
              res = await revertT11ToDraft({ mblId: row.id })
            } else {
              res = await voidMBL({ mblId: row.id })
            }
            if (res.success) {
              this.$message.success(res.errorMessage)
              this.getList()
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.error(error)
          }
        })
        .catch(() => {})
    },
    async handleRestore(row) {
      try {
        const res = await restoreMBL({ mblId: row.id })
        if (res.success) {
          this.$message.success(res.errorMessage)
          this.getList()
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleDelete(row) {
      try {
        const res = await deleteMBL({ mblId: row.id })
        if (res.success) {
          this.$message.success(res.errorMessage)
          this.getList()
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    uploadManifest(row) {
      this.dialogVisible13 = true
      this.rowData = row
      this.$store.commit('SET_MAIN_FAST_OBJ', { rowData: row })
    },
    showGGT(row) {
      const item = this.clearenceOptions.find(
        (a) => a.wbName === row.clearenceSupplier && a.isActived && a.isPushGGT,
      )
      return !row.isPushGGT && row.clearenceType !== 0 && item
    },
    showFMS(row, type) {
      const item = this.pickUpOptions.find(
        (a) =>
          a.wbName ===
            (type ? row.supplierUnstuffingName : row.pickUpSupplier) &&
          a.isActived &&
          a.fmsSecretKey,
      )
      return !row.isPushFMS && row.pickUpType !== 0 && item
    },
    // 分配跟进人
    assignFollowers(row) {
      // this.dialogVisible14 = true
      this.drawer6 = true
      this.rowData = row
    },
    ok5() {
      this.dialogVisible13 = false
      this.drawer7 = false
      this.getList(this.pagerConfig)
    },
    ok6() {
      this.dialogVisible13 = false
      this.drawer7 = true
      this.getList(this.pagerConfig)
    },
    editRemark(row) {
      this.rowData = row
      this.dialogVisible16 = true
    },
    clearanceStatus(row) {
      this.rowData = row
      this.dialogVisible18 = true
    }
  }
}
</script>

<style lang="less" scoped>
.view-contanier {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  .header {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tag-item {
    width: auto;
    height: 50px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 50px;
    margin-left: 30px;
    cursor: pointer;
    & + .tag-item {
      margin-left: 40px;
    }
  }
  .tag-acitve {
    color: rgb(18, 88, 188);
  }
  .tag2 {
    width: 100%;
    height: 48px;
    background: #fbfbfb;
    border-radius: 2px 2px 0px 0px;
    border: 1px solid #eeeeee;
    box-sizing: border-box;
    &:deep(.el-tabs__header) {
      margin: 15px 0;
    }
    &:deep(.el-tabs--card > .el-tabs__header) {
      border-bottom: 0;
    }
    &:deep(.el-tabs__nav) {
      border: 0;
    }
    &:deep(.el-tabs__item) {
      height: 24px;
      line-height: 24px;
      border: 0;
    }
  }
  .back {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    margin-left: 10px;
    span {
      margin: 0 10px;
    }
    .back-blue {
      font-size: 16px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
    }
  }
  .forecast-tip {
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #fe453d;
  }
  .opt {
    display: flex;
    & div {
      border-radius: 4px;
    }
    .search {
      position: relative;
      display: flex;
      width: 200px;
      margin-right: 5px;
      .searchPop {
        /deep/ .el-popover {
          z-index: 9999;
          right: 0;
        }
        .close {
          position: absolute;
          top: 6px;
          right: 10px;
          cursor: pointer;
          font-size: 20px;
        }
      }
      .input-search {
        width: 166px;
        height: 30px !important;
        /deep/ .el-input__inner {
          height: 30px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      .btn-search {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 33px;
        height: 30px;
        border: 1px solid #dbe4f2;
        border-left: 0;
        border-radius: 0 4px 4px 0;
        cursor: pointer;
        box-sizing: border-box;
      }
    }
    .hold {
      width: 80px;
      height: 30px;
      cursor: pointer;
      text-align: center;
      line-height: 30px;
      color: #fe453d;
      border: 1px solid #fe453d;
      border-radius: 2px;
      margin-right: 5px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      box-sizing: border-box;
    }
    .import {
      width: 82px;
      height: 30px;
      background: rgb(18, 88, 188);
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      display: flex;
      justify-content: center;
      cursor: pointer;
      align-items: center;
      margin-right: 5px;
      box-sizing: border-box;
    }
    .customer-list {
      width: 120px;
      height: 30px;
      border: 1px solid #dbe4f2;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      cursor: pointer;
      box-sizing: border-box;
    }
    .filter {
      height: 30px;
      margin-left: 5px;
    }
  }
  .data {
    width: 100%;
    height: calc(100% - 100px);
    p {
      text-align: left;
      & + p {
        margin-top: 4px;
      }
    }
    .tips-import {
      position: absolute;
      display: inline-block;
      width: auto;
      height: 20px;
      padding: 0 10px;
      font-size: 12px;
      line-height: 20px;
      top: 0;
      left: 0;
    }
    .tips-owner {
      color: rgba(53, 186, 131, 1);
      background: rgba(53, 186, 131, 0.1);
    }
    .tips-out {
      color: rgba(254, 69, 61, 1);
      background: rgba(254, 69, 61, 0.1);
    }
    .tips-box {
      position: absolute;
      top: 0;
      left: 0;
      width: auto;
    }
    .tips {
      padding: 0 8px;
      display: inline-block;
      height: 20px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #ff7444;
      background-color: rgba(255, 116, 68, 0.1);
      line-height: 20px;
      & + .tips {
        margin-left: 10px;
      }
    }
    .tips-date {
      width: auto;
      padding: 0 8px;
      display: inline-block;
      height: 20px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: rgba(32, 163, 50, 1);
      background-color: rgba(255, 116, 68, 0.1);
      line-height: 20px;
    }
    .tips-file {
      color: #1258bc;
      background: rgba(35, 149, 243, 0.1);
    }
    .custom-total {
      position: absolute;
      left: 0;
      display: flex;
      align-items: center;
      color: #999999;
      height: 42px;
      font-weight: 400;
      font-size: 14px;
      z-index: 1000;
      & > div {
        width: 80px;
        height: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        cursor: pointer;
        box-sizing: border-box;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #eeeeee;
        i,
        img {
          margin-right: 5px;
        }
      }
      .send {
        margin-left: 20px;
      }
      .delete {
        margin-left: 10px;
        .el-icon-delete {
          font-size: 16px;
          color: #999999;
        }
      }
      .renewal {
        margin-left: 20px;
        width: 100px;
      }
      .batchPayment {
        width: 120px;
        margin-left: 20px;
        border: 1px solid rgb(18, 88, 188);
        color: rgb(18, 88, 188);
      }
    }
  }
  .clearenceType {
    display: inline-block;
    padding: 4px 12px;
    width: 36px;
    height: 16px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    border-radius: 4px;
  }
  .clearenceType0 {
    color: #35ba83;
    background: rgba(53, 186, 131, 0.1);
  }
  .clearenceType1 {
    color: #9d67fe;
    background: rgba(157, 103, 254, 0.1);
  }
  .pickUpType {
    display: inline-block;
    padding: 4px 12px;
    width: auto;
    height: 16px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    text-align: center;
    box-sizing: content-box;
  }
  .pickUpType0 {
    color: rgb(18, 88, 188);
    background: rgba(35, 149, 243, 0.1);
  }
  .pickUpType1 {
    color: rgb(157, 103, 254);
    background: rgba(157, 103, 254, 0.1);
  }
  .pickUpType2 {
    color: #feaa4f;
    background: rgba(254, 170, 79, 0.1);
  }
  .pickUpType3 {
    color: rgb(53, 186, 131);
    background: rgb(224, 249, 238);
  }
  .pickUpType4 {
    color: rgb(157, 103, 254);
    background: rgb(233, 221, 255);
  }
  .supplier {
    margin-left: 8px;
    color: #7c8db5;
  }
  .isRefuse {
    position: absolute;
    top: 0;
    left: 0;
    width: 60px;
    height: 20px;
    background: #fe453d;
    border-radius: 0px 0px 10px 0px;
    font-size: 12px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
  .isOnLoad {
    position: absolute;
    top: 0;
    left: 0;
    width: 60px;
    height: 20px;
    background: #9d67fe;
    border-radius: 0px 0px 10px 0px;
    font-size: 12px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
  .link,
  .link2 {
    width: 28px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    line-height: 20px;
    cursor: pointer;
  }
  .table-opt > span + span .link {
    margin-left: 15px;
  }
  .link2 {
    margin-right: 15px;
  }
  .push {
    display: inline-block;
    padding: 0 6px;
    width: 24px;
    height: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    width: 50px;
    height: 20px;
    border-radius: 12px 12px 12px 12px;
    opacity: 1;
    border: 1px solid #9d67fe;
    cursor: pointer;
  }
  .refuse {
    color: #999999;
  }

  .infobox {
    display: flex;
    align-items: center;
  }
  .info {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    border-radius: 4px 4px 4px 4px;
    cursor: pointer;
  }
}
.sure {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  margin-left: 10px;
}
</style>

<!-- <style lang="less">
.new-message {
  position: relative;
  &::after {
    content: " ";
    width: 8px;
    height: 8px;
    background: #fe453d;
    opacity: 1;
    position: absolute;
    border-radius: 50%;
  }
}
</style> -->
